import Vue from "vue"
import Toasted from "vue-toasted"

Vue.use(Toasted, {
  iconPack: "fontawesome",
  position: "top-center",
  duration : 4000,
  action: {
    text: "Ok, entendi",
    onClick: (event, toast) => toast.goAway(0),
  },
})

export default class Message {

  static success(message, options) {

    Vue.toasted.show(message, { icon: "check-circle", ...options })
  }

  static info(message, options) {

    Vue.toasted.show(message, { icon: "info-circle", ...options })
  }

  static warn(message, options) {

    Vue.toasted.show(message, { icon: "exclamation-triangle", ...options })
  }

  static error(message, options) {

    Vue.toasted.show(message, { icon: "times", ...options })
  }

  static apiError(message, error) {

    console.log(error)

    Message.error(message, { theme: "bubble" })
  }
}
